module.exports = __webpack_public_path__ + "img/symbol_10.c5b6fdbd.png";